<script setup lang="ts">
import {
	DropdownMenuSeparator,
	type DropdownMenuSeparatorProps,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	DropdownMenuSeparatorProps & {
		class?: HTMLAttributes["class"];
	}
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<DropdownMenuSeparator
		v-bind="delegatedProps"
		:class="twMerge('-mx-1 my-1 h-px bg-muted', props.class)"
	/>
</template>
